export default {
    title: "EvaluationSystem",
    footer: ["Interview Management Expert", "A great helper for large-scale interviews", "Version{version}"],
    footerBoc: ["Bank of China Interview Scoring System"],
    placeholder: {
        email: "email",
        password: "password",
    },
    login: "login",
    detectionTips: "If there is a video schedule, please perform ",
    detectionButton: "device testing",
    failMsg: "User name or password error, please try again",
};
